import React from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";

// Check-in can never be undone by the client, so the tap must not be the last
// word — the warning is the whole reason this dialog exists.
function CheckInDialog({ state, onClose, onConfirm }) {
  const { open, booking, submitting } = state;

  return (
    <Dialog open={open} onClose={submitting ? undefined : onClose}>
      <DialogTitle>Check in</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Check in to {booking?.serviceName ? <strong>{booking.serviceName}</strong> : "this booking"}
          {booking?.time ? ` at ${booking.time}` : ""}? This can&apos;t be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>
          Not yet
        </Button>
        <Button onClick={onConfirm} variant="contained" disabled={submitting} sx={{ color: "common.white" }}>
          {submitting ? <CircularProgress size={18} /> : "Yes, check me in"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CheckInDialog;
